/*
 * Copyright (C) 2019 Frontier Developments PLC.
 */

import {ComponentOptions} from 'vue';
import Vue from 'vue';

/**
 * MetaInfo property decorator configuration.
 *
 * @author Noel Chapman <nchapman@frontier.co.uk>
 * @author Jonny Cook <jcook@frontier.co.uk>
 */
export default (options: ComponentOptions<Vue>, key: string, index: number): void => {
    // component options should be passed to the callback
    // and update for the options object affect the component
    if (!options.methods || !options.methods[key]) {
        return;
    }

    options['metaInfo'] = options.methods[key];
};


